module.exports = __webpack_public_path__ + "static/media/info.2da8e6d1.svg";